import layout from '../../styles/layout.module.css'
import guides from '../../styles/guides.module.css'
import Head from 'next/head'
import Container from 'react-bootstrap/Container'
import { useTranslation } from 'next-i18next'
import { Username } from '../../src/Authentication/models/Username'
import { getReflinksBySystems } from '../../src/Wikifacts/getReflinksBySystems'
import { ReferralSystem } from '../../src/ReferralSystem/models/ReferralSystem'
import { Reflink } from '../../src/ReferralSystem/models/Reflink'
import random from 'random'
import { getSampler } from '../../src/util/src/sampler'
import { GetStaticProps } from 'src/var/next/next'
import { withNamespace } from '../../src/util/src/i18next'
import { getTranslations } from 'src/var/next/next-i18next'
import { Markdown } from '../../components/Markdown'
import { nail } from '../../src/util/src/string'
import { getReferralUrl } from '../../src/Wikifacts/getReferralUrl'
import { Binance } from '../../src/Wikifacts/data/allReferralSystems'
import { useRouter } from 'next/router'
import { getContext, getRawContext } from '../../components/context'
import { DenisGorbachevReflinks } from '../../src/Wikifacts/data/allReflinks'
import { fromPackedReflinksToReflinks, PackedReflinksSchema } from '../../src/ReferralSystem/models/PackedReflink'
import { expect } from '../../src/util/src/chai'

export default function MakeMoneyOnBUSDViaAlpacaFinance(props: InstructionProps) {
  const { reflinks: reflinksFromProps } = props
  const sampler = getSampler<Reflink>(random)
  const router = useRouter()
  const rawContext = getRawContext(router.query.context)
  const context = rawContext ? getContext(rawContext) : []
  const packedReflinksResult = PackedReflinksSchema.safeParse(context)
  const packedReflinksFromContext = packedReflinksResult.success ? packedReflinksResult.data : []
  const reflinksFromContext = fromPackedReflinksToReflinks(packedReflinksFromContext)
  const reflinks = [...reflinksFromProps, ...reflinksFromContext]

  const { t } = useTranslation(translationNamespaces)
  const tCurrencies = withNamespace(t, 'currencies')
  const tPages = withNamespace(t, 'pages')
  const tc = withNamespace(t, 'common')
  const title = tPages(`defi.${pageName}.title`)
  const description = tPages(`defi.${pageName}.description`)
  const currencySymbol = 'BUSD'

  const risks = nail(`
    * Цена BUSD уйдет ниже $1:
      * Вероятность: низкая (BUSD выпускается биржей Binance, обеспечен запасами USD под управлением Binance)
    * Кража вашего приватного ключа:
      * Вероятность: низкая (если вы будете точно следовать инструкции по созданию приватного ключа)
  `)

  const binanceReferralUrl = getReferralUrl(sampler, systemsRec.Binance, reflinks)
  expect(binanceReferralUrl.endsWith('?ref=')).to.be.false
  // `https://accounts.binance.com/en/register?ref=22330587`
  const rest = nail(`
  ### Определите, сколько вы хотите инвестировать
   * Рекомендуемая сумма для начала: 100 USD
   
  ### Получите BUSD на свой адрес
  
  * [Зарегистрируйтесь на Binance](${binanceReferralUrl})
  * [Откройте страницу покупки BUSD за RUB](https://p2p.binance.com/en/trade/buy/BUSD?fiat=RUB&payment=ALL)
  * Купите BUSD
    * Сумма: {выбранная сумма инвестирования}
    * Адрес: {ваш адрес}
    * Нюансы:
      * Нужно пройти верификацию
      * Нужно включить 2-факторную аутентификацию
  
  ### Получите BNB на свой адрес
  
  BNB - это токен биржи Binance. Он нужен для оплаты транзакций в сети Binance Smart Chain.
  
  * [Зарегистрируйтесь на Binance](${binanceReferralUrl})
  * [Откройте страницу покупки BNB за RUB](https://p2p.binance.com/en/trade/buy/BUSD?fiat=RUB&payment=ALL)
  * Купите BNB
    * Сумма: {выбранная сумма инвестирования}
    * Адрес: {ваш адрес}
    * Нюансы:
      * Нужно пройти верификацию
      * Нужно включить 2-факторную аутентификацию

  ### Инвестируйте BUSD с помощью Alpaca Finance
    * [Откройте страницу займов Alpaca Finance](https://app.alpacafinance.org/lend)
    * Найдите строку "BUSD"
    * Нажмите "Deposit" в найденной строке
    * Введите сумму: {выбранная сумма инвестирования}
    * Нажмите "Approve"
    * Подтвердите транзакцию
    * Нажмите "Deposit"
    * Подтвердите транзакцию
  
  ## Итог
  
  Поздравляем! Ваш депозит BUSD успешно размещен и будет приносить ежедневный доход. Вы можете вывести деньги на свой адрес в любой момент.
  `)

  return (
    <Container className={layout.main}>
      <Head>
        <title>{title}</title>
        <meta name="description" content={description} />
      </Head>
      <h1 className={guides.instructionHeader}>💸 {title}</h1>
      <hr />
      <p>{description}</p>
      <ul>
        <li>{t('dividendAvailableAt')}: {tc('onWithdrawal')}</li>
        <li>{t('depositAt')}: {tc('onDemand')}</li>
        <li>{t('withdrawAt')}: {tc('onDemand')}</li>
        <li>{t('currency')}: {currencySymbol} ({tCurrencies(currencySymbol)})</li>
      </ul>
      <h2 className={guides.instructionSubheader}>🧐 Риски</h2>
      <hr />
      <Markdown>{risks}</Markdown>
      <h2 className={guides.instructionSubheader}>😎 Инструкция</h2>
      <hr />
      <Markdown>{rest}</Markdown>
    </Container>
  )
}

// const ParamsSchema = z.object({
//   username: UsernameSchema,
// })

const systemsRec = { Binance }
const systems = Object.values(systemsRec)

export const getStaticProps: GetStaticProps = async (context) => {
  const { locale, params } = context
  // const { username } = ParamsSchema.parse(params)
  // const promoterUsername = parsePageUsername(allUsernames)(username)
  const reflinks = getReflinksBySystems(DenisGorbachevReflinks, systems)
  const translations = await getTranslations(context, translationNamespaces)
  return {
    props: {
      ...translations,
      systems,
      reflinks,
    },
  }
}

const pageName = 'make-money-on-BUSD-via-AlpacaFinance'
const translationNamespaces = [pageName, 'currencies', 'pages', 'common']

// export async function getStaticPaths() {
//   const paths: string[] = [] // allUsernames.map(username => ({ params: { username } }))
//   return { paths, fallback: true }
// }

interface InstructionProps {
  usernames: Username[]
  systems: ReferralSystem[]
  reflinks: Reflink[]
}
